<template>
  <div>
    <el-card class="box-card">
      <div style="font-weight: bold;margin-bottom: 10px;">
        <!--生成集货码-->
        {{ $t('collectionCenter.GeneratePickupCode') }}
      </div>
      <el-form
        ref="collectionFormRef"
        size="small"
        label-position="top"
        :model="collectionForm"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <!--所属网点-->
            <el-form-item
              :label="$t('collectionCenter.belongDot')"
              prop="siteId"
              :rules="{required: true, message: $t('collectionCenter.pleaseChoose'), trigger: ['blur', 'change']}"
            >
              <el-select
                v-model="collectionForm.siteId"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                filterable
                remote
                reserve-keyword
                :remote-method="getSiteOption"
                style="width: 100%;"
                @visible-change="getSiteOptionVisible"
              >
                <el-option
                  v-for="item in siteAllList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--下一站-->
            <el-form-item
              :label="$t('GlobalSetObj.nextStation') + ':'"
              prop="nextStationId"
              :rules="{required: true, message: $t('GlobalSetObj.pleaseChoose'), trigger: ['blur', 'change']}"
            >
              <el-select
                v-model="collectionForm.nextStationId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                remote
                reserve-keyword
                :remote-method="getSiteOption"
                style="width: 100%;"
                @visible-change="getSiteOptionVisible"
                @change="changeNextSite()"
              >
                <el-option
                  v-for="item in siteAllList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--打印数量-->
            <el-form-item
              :label="$t('collectionCenter.printQ')"
              prop="printCount"
              :rules="{required: true, validator: checkPrintNum, trigger: ['blur', 'change']}"
            >
              <el-input
                v-model="collectionForm.printCount"
                :placeholder="$t('collectionCenter.PleaseEnterNumberBetween1And99')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--生成-->
            <el-button
              type="primary"
              size="small"
              style="margin-top: 28px;"
              @click="handleSubmit"
            >
              {{ $t('collectionCenter.generate') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="box-card">
      <el-form size="small" label-position="top">
        <el-row :gutter="10">
          <el-col :span="4">
            <!--集货码-->
            <el-form-item :label="$t('collectionCenter.PickupCode')">
              <el-input
                v-model="queryForm.params.code"
                :placeholder="$t('collectionCenter.pleaseInput')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--所属网点-->
            <el-form-item :label="$t('collectionCenter.belongD')">
              <el-select
                v-model="queryForm.params.siteId"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                filterable
                remote
                reserve-keyword
                :remote-method="getSiteOption"
                style="width: 100%;"
                @visible-change="getSiteOptionVisible"
              >
                <el-option
                  v-for="item in siteAllList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--下一站-->
            <el-form-item :label="$t('GlobalSetObj.nextStation')">
              <el-select
                v-model="queryForm.params.nextStationId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                remote
                reserve-keyword
                :remote-method="getSiteOption"
                style="width: 100%;"
                @visible-change="getSiteOptionVisible"
              >
                <el-option
                  v-for="item in siteAllList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--创建时间-->
            <el-form-item :label="$t('collectionCenter.CreationTime')">
              <el-date-picker
                v-model="timeArr"
                :picker-options="pickerOptions"
                :clearable="true"
                :default-time="['00:00:00', '23:59:59']"
                :format="$i18n.locale==='zh'?zhDate:ptDate"
                :placeholder="$t('newOrder.SelectDatetime')"
                range-separator="~"
                style="width:100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div style="margin-top: 28px;">
              <el-button
                type="primary"
                size="small"
                @click="handleQuery"
              >
                {{ $t('collectionCenter.search') }}
              </el-button>
              <el-button size="small" @click="onReset">
                {{ $t('collectionCenter.reset') }}
              </el-button>
              <el-tooltip
                class="item"
                effect="dark"
                :content="expandQuery === false ? $t('orderCenterCont.ExpandQuery') : $t('orderCenterCont.CollapseQuery')"
                placement="top"
              >
                <el-button size="small" @click="onExpandQuery">
                  <i v-if="expandQuery === false" class="el-icon-d-arrow-right" style="transform: rotate(90deg)" />
                  <i v-else class="el-icon-d-arrow-right" style="transform: rotate(-90deg)" />
                </el-button>
              </el-tooltip>
            </div>
          </el-col>
        </el-row>
        <div v-if="expandQuery">
          <el-row :gutter="10">
            <el-col :span="6">
              <!--状态-->
              <el-form-item :label="$t('collectionCenter.stateZT')">
                <el-select
                  v-model="queryForm.params.status"
                  :placeholder="$t('collectionCenter.pleaseChoose')"
                  clearable
                  filterable
                  style="width: 100%;"
                >
                  <!--全部-->
                  <el-option key="0" :label="$t('collectionCenter.tudo')" :value="null" />
                  <!--未绑定-->
                  <el-option key="1" :label="$t('collectionCenter.NotBound')" :value="0" />
                  <!--已绑定-->
                  <el-option key="2" :label="$t('collectionCenter.Bound')" :value="1" />
                  <!--已装车-->
                  <el-option key="3" :label="$t('GlobalSetObj.Carregado')" :value="2" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-card>
    <el-card class="box-card">
      <div style="margin-bottom: 10px;">
        <el-button
          type="primary"
          size="small"
          @click="handlePrint(2, null)"
        >
          {{ $t('collectionCenter.Print') }}
        </el-button>
      </div>
      <el-table
        :data="tableData"
        border
        :header-cell-style="{background:'#ebebeb',color:'#000'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
          fixed="left"
        />
        <el-table-column
          :label="$t('collectionCenter.ind')"
          align="center"
          width="60px"
          fixed="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!--集货码-->
        <el-table-column :label="$t('collectionCenter.PickupCode')" prop="code" min-width="200" />
        <!--所属网点-->
        <el-table-column :label="$t('collectionCenter.belongD')" prop="siteName" min-width="160" />
        <!--下一站-->
        <el-table-column :label="$t('GlobalSetObj.nextStation')" prop="nextStationName" min-width="160" />
        <!--创建时间-->
        <el-table-column :label="$t('collectionCenter.CreationTime')" prop="createTime" min-width="180" />
        <!--创建人-->
        <el-table-column :label="$t('collectionCenter.creator')" prop="createUserName" min-width="160" />
        <!--状态-->
        <el-table-column :label="$t('collectionCenter.stateZT')" min-width="160" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" type="info">
              {{ $t('collectionCenter.NotBound') }}
            </el-tag>
            <el-tag v-if="scope.row.status === 1" type="success">
              {{ $t('collectionCenter.Bound') }}
            </el-tag>
            <el-tag v-if="scope.row.status === 2" type="primary">
              {{ $t('GlobalSetObj.Carregado') }}
            </el-tag>
          </template>
        </el-table-column>
        <!--已绑定袋数-->
        <el-table-column :label="$t('collectionCenter.BoundBags')" prop="boundBagCount" min-width="160" />
        <!--已绑定包裹数-->
        <el-table-column :label="$t('collectionCenter.BoundPackages')" prop="boundPackageCount" min-width="160" />
        <!--总开票金额(BRL)-->
        <el-table-column :label="$t('collectionCenter.TotalInvoiceAmount') + '(BRL)'" prop="totalInvoiceAmount" min-width="160">
          <template slot="header">
            <span style="color: #f81a9c;">{{ $t('collectionCenter.TotalInvoiceAmount') + '(BRL)' }}</span>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.totalInvoiceAmount }}</span>
          </template>
        </el-table-column>
        <!--操作-->
        <el-table-column
          :label="$t('collectionCenter.operation')"
          min-width="180"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <!--打印-->
            <el-button
              v-if="scope.row.status !== 2"
              type="text"
              size="small"
              @click="handlePrint(1, scope.row)"
            >
              {{ $t('collectionCenter.Print') }}
            </el-button>
            <!--详情-->
            <el-button
              v-if="scope.row.status !== 0"
              type="text"
              size="small"
              @click="handleEdit(scope.row)"
            >
              {{ $t('collectionCenter.detail') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--  分页  -->
      <el-pagination
        :current-page="queryForm.pageNumber"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0;float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <!--打印PDF-->
    <el-dialog
      :title="$t('collectionCenter.Print') + ' PDF'"
      :visible.sync="showPrintWindow"
      width="800px"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
    >
      <printWindow ref="printWindowRef" :key="printWindowKey" :print-data="printData" />
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="small"
          @click="handlePrintConfirm"
        >
          {{ $t('collectionCenter.Print') }}
        </el-button>
        <el-button size="small" @click="showPrintWindow = false">{{ $t('collectionCenter.close') }}</el-button>
      </div>
    </el-dialog>
    <el-drawer
      :title="$t('collectionCenter.PickupCode') + ' - ' + rowData.code"
      :visible.sync="showDetailWindow"
      direction="ltr"
      :append-to-body="true"
      :close-on-press-escape="false"
      size="80%"
    >
      <detailWindow :key="detailWindowKey" :row-data="rowData" />
    </el-drawer>
  </div>
</template>
<script>
import {
  query10Site
} from '@/api/bulkyExpress';
import printWindow from './printWindow.vue';
import detailWindow from './detail.vue';
import { generateCollectCode, queryCollectCodePage } from '@/api/automaticSorting';
const dayjs = require('dayjs');
const startTime = dayjs().format('YYYY-MM-DD') + ' 00:00:00';
const endTime = dayjs().format('YYYY-MM-DD') + ' 23:59:59'; // 设置此刻的时间
export default {
  name: 'PreLoadTruckPickup',
  components: {
    printWindow,
    detailWindow
  },
  data() {
    const checkPrintNum = (rule, value, callback) => {
      const regex = /^(?:[1-9]|[1-9][0-9])$/;
      if (!value) {
        callback(new Error(this.$t('collectionCenter.PleaseEnterNumberBetween1And99')));
      } else {
        if (regex.test(value)) {
          callback();
        } else {
          callback(new Error(this.$t('collectionCenter.PleaseEnterNumberBetween1And99')));
        }
      }
    };
    return {
      collectionForm: {
        siteId: '',
        nextStationId: '',
        nextStationCode: '',
        printCount: 1
      },
      siteAllList: [],
      checkPrintNum,
      timeArr: [startTime, endTime],
      pickerMinDate: '',
      pickerRange: 365 * 24 * 60 * 60 * 1000, // 可选择日期范围 为15天
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (time.getTime() > (this.pickerMinDate + this.pickerRange)) || (time.getTime() < (this.pickerMinDate - this.pickerRange));
          }
          return false;
        }
      },
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          code: null,
          siteId: null,
          nextStationId: null,
          startTime: null,
          endTime: null,
          status: null
        }
      },
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      tableData: [],
      total: 0,
      selectedData: [],
      showPrintWindow: false,
      printWindowKey: new Date().getTime(),
      printData: [],
      showDetailWindow: false,
      detailWindowKey: new Date().getTime(),
      rowData: {},
      expandQuery: false
    };
  },
  created() {
    console.log(this.$store.getters, '===this.$store.getters');
    this.collectionForm.siteId = this.$store.getters.siteId;
    this.queryForm.params.siteId = this.$store.getters.siteId;
    this.siteAllList = [
      {
        id: this.$store.getters.siteId,
        name: this.$store.getters.siteName
      }
    ];
    // this.getSiteOption(this.$store.getters.siteName);
    this.handleQuery();
  },
  mounted() {
    this.bus.$on('updateTableData', () => {
      this.getTableData();
    });
  },
  methods: {
    // 展开收起查询
    onExpandQuery() {
      this.expandQuery = !this.expandQuery;
    },
    // 下一站选项变化
    changeNextSite() {
      this.siteAllList.map(item => {
        if (this.collectionForm.nextStationId === item.id) {
          this.collectionForm.nextStationCode = item.code;
        }
      });
    },
    // 重置生成集货码参数
    resetCollectionForm() {
      this.collectionForm.nextStationId = '';
      this.collectionForm.nextStationCode = '';
      this.collectionForm.siteId = this.$store.getters.siteId;
      this.collectionForm.printCount = 1;
      this.getSiteOption(this.$store.getters.siteName);
      this.$refs.collectionFormRef.resetFields();
    },
    // 生成集货码
    handleSubmit() {
      this.$refs.collectionFormRef.validate(valid => {
        if (valid) {
          generateCollectCode(this.collectionForm).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.getTableData();
              this.resetCollectionForm();
            }
          });
        }
      });
    },
    // 网点选项弹出打开时查询网点
    getSiteOptionVisible(val) {
      if (val) {
        this.getSiteOption();
      }
    },
    // 获取所有网点
    getSiteOption(name = '') {
      query10Site(name).then(res => {
        if (res.code === 200) {
          this.siteAllList = res.data;
        }
      });
    },
    // 查询条件整理
    queryFormHandle() {
      if (Array.isArray(this.timeArr) && this.timeArr.length === 2) {
        this.queryForm.params.startTime = this.timeArr[0];
        this.queryForm.params.endTime = this.timeArr[1];
      } else {
        this.queryForm.params.startTime = null;
        this.queryForm.params.endTime = null;
      }
    },
    // 搜索
    handleQuery() {
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 获取列表数据
    getTableData() {
      this.queryFormHandle();
      if (!this.queryForm.params.startTime && !this.queryForm.params.endTime && !this.queryForm.params.code) {
        this.$message.error(this.$t('collectionCenter.PleaseSelectTime'));
        return;
      }
      queryCollectCodePage(this.queryForm).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 列表勾选
    handleSelectionChange(val) {
      this.selectedData = val;
    },
    // 重置
    onReset() {
      this.queryForm.pageNumber = 1;
      this.queryForm.params = {
        code: null,
        siteId: this.$store.getters.siteId,
        nextStationId: null,
        startTime: null,
        endTime: null,
        status: null
      };
      this.timeArr = [startTime, endTime];
      this.handleQuery();
    },
    // 打开打印弹窗
    handlePrint(type, row) {
      if (type === 1) {
        this.printData = [row];
      } else {
        const printData = [];
        this.selectedData.map(item => {
          if (item.status !== 2) {
            printData.push(item);
          }
        });
        if (printData.length === 0) {
          this.$message.error(this.$t('orderCenterCont.PleaseSelectDataWithStatusBoundOrUnbound'));
          return;
        }
        this.printData = printData;
      }
      this.showPrintWindow = true;
      this.printWindowKey = new Date().getTime();
    },
    // 确认打印
    handlePrintConfirm() {
      this.$refs.printWindowRef.confirmPrint();
    },
    // 详情
    handleEdit(row) {
      this.rowData = row;
      this.showDetailWindow = true;
      this.detailWindowKey = new Date().getTime();
    },
    // 每页显示数量变化
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getTableData();
    },
    // 翻页
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getTableData();
    }
  }
};
</script>
